import React from 'react'
import DisplayConditionNode from '../components/DisplayConditionNode'

export default ({ node }) => (
  <DisplayConditionNode operator={node.extras.operator} value={node.extras.value} />
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/DateTimeIs/DateTimeIsDisplay.jsx